import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/browser";
import * as serviceWorker from "./serviceWorker";
import { utils } from "./utils";
import App from "./App";
import store from "./store";
import "./index.scss";

const { NODE_ENV, REACT_APP_GA_TRACKING_ID, REACT_APP_SENTRY_DSN } = process.env;

window.gtag = function() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
};

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

utils.logGreen(`Load ${NODE_ENV}`);

if (NODE_ENV === "production") {
    if (REACT_APP_GA_TRACKING_ID && REACT_APP_GA_TRACKING_ID !== "") {
        window.gtag("js", new Date());
        window.gtag("config", REACT_APP_GA_TRACKING_ID);
        utils.logGreen("Analitics");
    }
    if (REACT_APP_SENTRY_DSN && REACT_APP_SENTRY_DSN !== "") {
        Sentry.init({ dsn: REACT_APP_SENTRY_DSN });
        utils.logGreen("Load Sentry");
    }
    console.warn = () => {};
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
